import { useEffect, useRef } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { AppendState as UserAppendState } from 'src/core/state/user';

import { identifyUser, ensureKlaviyoIdentified } from '../klaviyo.utils';

const selector = (s: UserAppendState) => ({
    email: s.user.data?.email,
    firstName: s.user.data?.firstname,
    lastName: s.user.data?.lastname,
});

export function useKlaviyoIdentify(): void {
    const { email, firstName, lastName } = useSelector(selector, shallowEqual);
    const identifiedEmailRef = useRef<string | null>(null);
    const anonymousIdentifiedRef = useRef(false);

    useEffect(() => {
        // For logged-in users: identify with email
        if (email && identifiedEmailRef.current !== email) {
            identifiedEmailRef.current = email;
            anonymousIdentifiedRef.current = false;

            identifyUser({
                $email: email,
                $first_name: firstName || undefined,
                $last_name: lastName || undefined,
            });
            return;
        }

        // For anonymous users: ensure Klaviyo is initialized for tracking
        if (!email && !anonymousIdentifiedRef.current) {
            anonymousIdentifiedRef.current = true;
            ensureKlaviyoIdentified();
        }
    }, [email, firstName, lastName]);
}
